import memberRequest from '@formosa/shared/api/memberRequest';

// Optional member Authorization is attached by the shared client; actor identity never comes from route data.
export default memberRequest;
